import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCreateSharingSchedule } from "./createSharingSchedule.request";

const useCreateSharingSchedule = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateSharingSchedule,
    ...options
  });
};

export default useCreateSharingSchedule;
